import items from './components/items/items';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [ items]
};

export default menuItems;
